import { Spacing } from "../theme/types"

interface LineProps {
  height?: Spacing
  className?: string
}

export const Line = ({ height, className }: LineProps) => (
  <div
    className={`w-px bg-quaternary ${className ?? ""}`}
    style={height ? { height: `var(--spacing-${height})` } : { height: "100%" }}
  />
)
